import { useRef } from 'react';

import { IGoogleMapsState } from 'appointment-tool/types';
import { DEFAULT_BOUNDS } from 'appointment-tool/constants';

import currentLocationIcon from '../images/markers/current-location-icon.png';

export const useGoogleMaps = () => {
    const infoWindowNode = document.createElement('div');

    const googleMapsState = useRef<IGoogleMapsState>({
        currentLocationMarker: undefined,
        defaultBounds: new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng({
                lat: DEFAULT_BOUNDS.sw.lat,
                lng: DEFAULT_BOUNDS.sw.lng,
            }),
            new window.google.maps.LatLng({
                lat: DEFAULT_BOUNDS.ne.lat,
                lng: DEFAULT_BOUNDS.ne.lng,
            })
        ),
        geocoder: new window.google.maps.Geocoder(),
        infoWindowNode,
        infoWindow: new window.google.maps.InfoWindow({
            content: infoWindowNode,
        }),
        mapObject: undefined,
        markerClusterer: undefined,
        markers: [],
    });

    const setCurrentLocationMarker = (location: {
        lat: number;
        lng: number;
    }) => {
        googleMapsState.current.currentLocationMarker = new window.google.maps.Marker(
            {
                position: location,
                icon: {
                    url: currentLocationIcon,
                    scaledSize: new window.google.maps.Size(30, 30),
                },
                map: googleMapsState.current.mapObject,
            }
        );
    };

    const setMapObject = (mapObject: google.maps.Map) => {
        googleMapsState.current.mapObject = mapObject;
    };

    return { googleMapsState, setCurrentLocationMarker, setMapObject };
};
